import React from "react";
import "swiper/swiper.min.css";
import SwiperCore, { Mousewheel, Pagination } from "swiper/core";
import "./Gallery.css";
import SingleGalleryImg from "./singleGalleryImage/SingleGalleryImg";
import { atGallery } from "../galleryImages";
import { Link } from "react-router-dom";

// install Swiper modules
SwiperCore.use([Mousewheel, Pagination]);

function HomeboundFieldworkGallery() {
  return (
    <div className="gallery">
      {atGallery.map((i) => (
        <div className="item">
          <SingleGalleryImg key={i._id} image={i} />
        </div>
      ))}

      <div className="pagination">
        <div className="pageLeft"></div>
        <Link to="/gleamin">
          <div className="pageRight">Gleamin' &#62;</div>
        </Link>
      </div>
    </div>
  );
}

export default HomeboundFieldworkGallery;
